<div class="m-5">
  <table
    mat-table
    [dataSource]="dataSource"
    class="mat-elevation-z8"
    matTableResponsive
  >
    <mat-progress-bar mode="indeterminate" *ngIf="loading"></mat-progress-bar>

    <ng-container matColumnDef="name">
      <th mat-header-cell *matHeaderCellDef>Name</th>
      <td mat-cell *matCellDef="let item">
        {{ item.firstName }} {{ item.lastName }}
      </td>
    </ng-container>

    <ng-container matColumnDef="email">
      <th mat-header-cell *matHeaderCellDef>Email</th>
      <td mat-cell *matCellDef="let item">{{ item.email }}</td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
  </table>
</div>

<mat-paginator
  [pageSizeOptions]="[5, 10, 20]"
  [length]="totalCount"
  showFirstLastButtons
  aria-label="Select page of colleges"
  (page)="changePage($event)"
>
</mat-paginator>
